import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonBlock } from 'src/app/core/models/message-blocks';
import { MessageBlockBaseDirective } from '../../message-block-base.directive';

@Component({
  selector: 'app-mr-button',
  templateUrl: './mr-button.component.html',
  styleUrls: ['./mr-button.component.scss'],
})
export class MrButtonComponent extends MessageBlockBaseDirective {
  @Input() block!: ButtonBlock;
  @Output() action = new EventEmitter<string>();

  onClick(): void {
    if (this.block.action) this.action.emit(this.block.action);
  }
}
